import styled, { keyframes } from 'styled-components';
import { bounce } from 'react-animations';

const bounceAnimation = keyframes`${bounce}`;

export const BouncyContainerV = styled.div`
  animation: 4s ${bounceAnimation} infinite;
`;